import Enum from "../../../../../../enums/Enum";

const DiagnosisEnum = new Enum({
    STABLE: {name: "Stable"},
    ACTIVE: {name: "Active"}
});

export default DiagnosisEnum;